// extracted by mini-css-extract-plugin
export var chevronIcon = "_5u-2";
export var teamName = "_5u-1";
export var teamSwitcherButton = "_5u-0";